import React from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-awesome-slider/dist/styles.css';
import { Helmet } from 'react-helmet';
import "./Footer.css";

const getJobId = (job, index) => job?._id || job?.id || index;
const slugify = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
const getJobSlug = (job, index) => {
    const titleSlug = slugify(job?.job || job?.title || 'career-opening');
    return `${titleSlug}-${getJobId(job, index)}`;
};

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            number: '',
            subject: '',
            message: '',
            toDate: '',
            formErrors: {},
            setContactFormBool: false,
            show: false,
            isOpen: false,
            isActive: false,
            selectedDate: null,
            isAnimationRunning: true,
            autoplay: true        
        }
        this.onClickShowdetails = this.onClickShowdetails.bind(this);
        
    }

    onClickShowdetails(job, index) {
        localStorage.setItem("Job", JSON.stringify(job));
        window.location.href = `/career/${getJobSlug(job, index)}`;
    }

    render() {
        const fallbackServiceCategories = [
            {
                title: "Game Development",
                items: [
                    { name: "Unity Game Development", href: "/unity" },
                    { name: "Unreal Engine Development", href: "/gamedevelopment" },
                    { name: "2D & 3D Games", href: "/gamedevelopment" },
                    { name: "Multiplayer Games", href: "/multiplayer-games" },
                    { name: "Mobile, PC, Web & Console Games", href: "/mobile-pc-console-games" },
                    { name: "AR / VR / MR Games", href: "/ar-vr-games" },
                ],
            },
            {	
                title: "Mobile App Development", 
                items: [
                    {name: "Android App Development", href: "/android-app-development"},
                    {name: "iOS App Development", href: "/ios-app-development"},
                    {name: "Cross-Platform Apps", href: "/cross-platform-apps"}
                ]
            },
            {
                title: "Web Development",
                items: [
                    { name: "Business Websites", href: "/business-websites" },
                    { name: "Web Applications", href: "/web-applications" },
                    { name: "Admin Panels & Dashboards", href: "/admin-panels-dashboards" },
                ],
            },
            {
                title: "Backend & Cloud Development",
                items: [
                    { name: "APIs", href: "/game-api-development" },
                    { name: "Game Servers", href: "/game-server-development" },
                    { name: "Multiplayer Backend", href: "/multiplayer-backend-development" },
                    { name: "Database Design", href: "/game-database-design" },
                    { name: "Cloud Deployment", href: "/game-cloud-deployment" },
                    { name: "DevOps", href: "/game-devops-services" },
                ],
            },
            {
                title: "UI/UX Design",
                items: [
                    { name: "Mobile UI", href: "/mobile-ui-design" },
                    { name: "Game UI", href: "/game-ui-design" },
                    { name: "Wireframes", href: "/game-wireframes" },
                    { name: "Prototyping", href: "/game-prototyping" },
                ],
            },
            {
                title: "3D Modeling",
                items: [
                    { name: "Character Modeling", href: "/character-modeling" },
                    { name: "Environment Modeling", href: "/environment-modeling" },
                    { name: "Props & Weapons", href: "/props-weapons-modeling" },
                    { name: "Vehicles", href: "/vehicle-modeling" },
                    { name: "Architectural Models", href: "/architectural-modeling" },
                    { name: "Low-Poly & High-Poly Assets", href: "/low-poly-high-poly-assets" },
                    { name: "PBR Texturing", href: "/pbr-texturing" },
                    { name: "UV Mapping", href: "/uv-mapping" },
                    { name: "Sculpting", href: "/blender-sculpting" },
                ],
            },
            {
                title: "3D Animation",
                items: [
                    { name: "Character Animation", href: "/character-animation" },
                    { name: "Creature Animation", href: "/creature-animation" },
                    { name: "Rigging & Skinning", href: "/rigging-skinning" },
                    { name: "Facial Animation", href: "/facial-animation" },
                    { name: "Motion Capture Cleanup", href: "/motion-capture-cleanup" },
                    { name: "Cinematics", href: "/game-cinematics" },
                    { name: "Product Animations", href: "/product-animations" },
                ],
            },
            {
                title: "2D Art & Animation",
                items: [
                    { name: "Character Design", href: "/game-character-design" },
                    { name: "Concept Art", href: "/game-concept-art" },
                    { name: "Illustrations", href: "/game-illustrations" },
                    { name: "Sprite Animation", href: "/sprite-animation" },
                    { name: "Spine Animation", href: "/spine-animation" },
                    { name: "UI Assets", href: "/game-ui-assets" },
                ],
            },
            {
                title: "VFX & Technical Art",
                items: [
                    { name: "Particle Effects", href: "/game-particle-effects" },
                    { name: "Shader Development", href: "/game-shader-development" },
                    { name: "Lighting", href: "/game-lighting" },
                    { name: "Optimization", href: "/game-art-optimization" },
                ],
            },
            {
                title: "QA & Testing",
                items: [
                    { name: "Functional Testing", href: "/game-functional-testing" },
                    { name: "Performance Testing", href: "/Service" },
                    { name: "Device Compatibility", href: "/mobiledevelopment" },
                    { name: "Bug Fixing", href: "/game-bug-fixing" },
                ],
            },
            {
                title: "Live Operations & Support",
                items: [
                    { name: "Game Maintenance", href: "/game-maintenance" },
                    { name: "Content Updates", href: "/game-content-updates" },
                    { name: "Analytics", href: "/game-analytics" },
                    { name: "Monetization", href: "/game-monetization" },
                    { name: "Ad Integration", href: "/game-ad-integration" },
                    { name: "Store Publishing", href: "/game-store-publishing" },
                ],
            }
        ];

        const footerServiceCategories = Array.isArray(this.props.apiHeaderData) && this.props.apiHeaderData.length > 0
            ? this.props.apiHeaderData
            : fallbackServiceCategories;

        const careerItems = Array.isArray(this.props.apiCareerData) ? this.props.apiCareerData : [];



        const footerwidgetarea = 
            <div className="widget-area footer-widget-area-full" >
                <div className="container-fluid">
                    <div className="footer-main-layout">
                        <div className="footer-company-column">
                            <div className="widget footer-widget footer-company-widget">

                                <h3 className="widget_title">OENGINES GAMES LLP</h3>
                                <div className="as-widget-about">

                                    <p className="about-text">Oengines Games LLP builds games, mobile apps, web platforms, backend systems, UI/UX, 2D/3D art, animation, QA, and live product support for businesses that need reliable digital delivery.</p>
                                    <div className="footer-company-tags">
                                        <span>Game</span>
                                        <span>Web</span>
                                        <span>Mobile</span>
                                        <span>Art</span>
                                        <span>QA</span>
                                    </div>
                                    <div className="as-social">
                                        <a href="https://www.facebook.com/oe.studio091"><i className="fab fa-facebook-f"></i></a>
                                        <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a>
                                        <a href="https://www.linkedin.com/company/oenginesgames"><i className="fab fa-linkedin-in"></i></a> 
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="footer-directory-grid">
                            <div className="widget widget_nav_menu footer-widget footer-directory-card footer-careers-widget">
                                <h4>Careers</h4>
                                <ul className="menu footer-career-list">
                                    {careerItems.length > 0 ? (
                                        careerItems.slice(0, 6).map((job, index) => (
                                            <li key={"footerCareer" + index}>
                                                <a href={`/career/${getJobSlug(job, index)}`} onClick={(event) => {
                                                    event.preventDefault();
                                                    this.onClickShowdetails(job, index);
                                                }}>{job.job || job.title || "Career Opening"}</a>
                                            </li>
                                        ))
                                    ) : (
                                        <li><a href="/career">View Open Positions</a></li>
                                    )}
                                </ul>
                            </div>

                            <div className="widget widget_nav_menu footer-widget footer-directory-card footer-company-links-widget">
                                <h4>Company</h4>
                                <ul className="menu">
                                    <li><a href="/about">About Us</a></li>
                                    <li><a href="/career">Careers</a></li>
                                    <li><a href="/contact">Contact Us</a></li>
                                </ul>
                            </div>

                            {footerServiceCategories.map((category) => (
                                <div className="footer-service-category footer-directory-card" key={category.title}>
                                    <h4>{category.title}</h4>
                                    <ul className="menu">
                                        {(category.items || []).map((item) => (
                                            <li key={category.title + item.name}><a href={item.href}>{item.name}</a></li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        

        return (
        <>
            <Helmet>               
               
                <link href="https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/css/demo.css" />
                <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" />
                <link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet" />
                <script href="https://cdnjs.cloudflare.com/ajax/libs/jquery-circle-progress/1.2.2/circle-progress.min.js"></script>
                <script href="https://cdnjs.cloudflare.com/ajax/libs/jquery-circle-progress/1.2.2/circle-progress.js"></script>
                <script src="https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/js/TweenLite.min.js"></script>
                <script src="https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/js/rAF.js"></script>
                <script src="https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/js/EasePack.min.js"></script>
                <script src="https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js"></script>              
                <script src="../assets/js/slick-min.js"></script>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/modernizr/2.8.3/modernizr.min.js" type="Javascript"></script>
                <script scr="https://s3-us-west-2.amazonaws.com/s.cdpn.io/72900/jquery.knob.min.js"></script>
                <script src="https://cdn.jsdelivr.net/npm/tsparticles@2.2.3/tsparticles.bundle.min.js"></script>
                <script src="../assets/js/script.js" type="Javascript"></script>
                <script></script>
            </Helmet>

                <footer className="footer-wrapper footer-layout1 ne">
                    <div className="parti-cl">
                        <div _ngcontent-mfs-c21="" className="header-lines-decoration">
                            <span _ngcontent-mfs-c21="" className="bg-secondary-color"></span>
                            <span _ngcontent-mfs-c21="" className="bg-blue"></span>
                            <span _ngcontent-mfs-c21="" className="bg-white-light"></span>
                            <span _ngcontent-mfs-c21="" className="bg-orange-light"></span>
                            <span _ngcontent-mfs-c21="" className="bg-red"></span>
                            <span _ngcontent-mfs-c21="" className="bg-green"></span>
                            <span _ngcontent-mfs-c21="" className="bg-secondary-color"></span>
                        </div>
                        <div className="footer-top">
                            <div className="logo-bg"></div>
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-xl-3">
                                        <div className="footer-logo"><a href="/"><img
                                            src="/assets/img/white-logo.png" alt="Oengines Games LLP" /></a></div>
                                    </div>
                                    <div className="col-xl-9 right-side">
                                        <div className="footer-contact-wrap">
                                            <div className="footer-contact">
                                                <div className="footer-contact_icon"><i className="fas fa-phone"></i></div>

                                                <div className="media-body"><span className="footer-contact_text">Quick Call Us:</span> <a
                                                    href="tel:+919427310521" className="footer-contact_link">(+91) - 9427310521</a></div>
                                            </div>
                                            <div className="footer-contact">
                                                <div className="footer-contact_icon"><i className="fas fa-envelope"></i></div>
                                                <div className="media-body" style={{ marginLeft: "14px" }}><span className="footer-contact_text">Mail Us On:</span> <a
                                                    href="mailto:support@oengines.com" className="footer-contact_link">support@oengines.com</a>
                                                </div>
                                            </div>
                                            {/* <div className="footer-contact">
                                                <div className="footer-contact_icon"><i className="fas fa-location-dot"></i></div>
                                                <div className="media-body" style={{ marginLeft: "14px" }}><span className="footer-contact_text">Visit Location:</span> <a
                                                    href="https://www.google.com/maps" className="footer-contact_link">436, Amby vally arcade,Utran, Surat Gujarat</a></div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div _ngcontent-mfs-c21="" className="header-lines-decoration">
                            <span _ngcontent-mfs-c21="" className="bg-secondary-color"></span>
                            <span _ngcontent-mfs-c21="" className="bg-blue"></span>
                            <span _ngcontent-mfs-c21="" className="bg-white-light"></span>
                            <span _ngcontent-mfs-c21="" className="bg-orange-light"></span>
                            <span _ngcontent-mfs-c21="" className="bg-red"></span>
                            <span _ngcontent-mfs-c21="" className="bg-green"></span>
                            <span _ngcontent-mfs-c21="" className="bg-secondary-color"></span>
                        </div>
                        
                        {footerwidgetarea}
                        
                        <div className="pb" id="pb"></div>
                        <div className="pc">
                            <div className="ol">
                                <a href="#" id="btn-back-to-top">
                                    <i className="fa-solid fa-arrow-up">
                                    </i>
                                </a>
                            </div>
                            <div className="bg" id="bg"></div>
                        </div>
                    </div>
                    <div className="copyright-wrap bg-title new-bg-title">
                        <div className="container abc">
                            <div className="row justify-content-between align-items-center">
                                <div className="col-lg-6">
                                    <p className="copyright-text text-white">Copyright <i className="fal fa-copyright"></i> {sessionStorage.getItem("currentYear")} <a
                                        href="#"> OENGINES GAMES LLP</a></p>
                                </div>
                                <div className="col-lg-6 text-end d-none d-lg-block">
                                    <div className="footer-links">
                                        <ul className="d-flex" style={{ float: "right" }}>
                                            <li><a href="/terms">Terms & Conditions</a></li>
                                            <li><a href="/career">Careers</a></li>
                                            <li><a href="/home/privacy">Privacy Policy</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-left"><img src="/assets/img/shape/footer_shape_2.svg" alt="shape" /></div>
                </footer>
               


        </>
    )}
}
export default Footer;
